"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _List = require("./List");

var _userProfile = require("user-profile");

var _decorators = require("decorators");

var _AccountList = require("./AccountList");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp;

var ApplicationRejectedItem = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(ApplicationRejectedItem, _Component);

  function ApplicationRejectedItem() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, ApplicationRejectedItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(ApplicationRejectedItem)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "item", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "onSelected", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "asLink", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "selected", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.state = {
      userProfile: (0, _userProfile.getUserProfileNow)()
    };
    return _this;
  }

  babelHelpers.createClass(ApplicationRejectedItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      (0, _userProfile.getUserProfile)().then(function (userProfile) {
        _this2.setState({
          userProfile: userProfile
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.item.commenter) {
        return _react.default.createElement(_List.NotificationItem, {
          asLink: this.asLink,
          onSelected: this.onSelected,
          item: this.item,
          overlayType: "danger",
          overlay: this.item.application.isScholarship ? 'attach_money' : 'description',
          selected: this.selected
        }, _react.default.createElement(_AccountList.Account, {
          account: this.item.commenter
        }), ' has declined ', this.state.userProfile && this.state.userProfile.id == this.item.account.id ? 'your' : _react.default.createElement(_AccountList.Account, {
          account: this.item.account,
          suffix: "'s"
        }), this.item.application.isScholarship && ' scholarship', ' application for ', _react.default.createElement("span", {
          className: "catalogItem"
        }, this.item.catalogItem.title), '.');
      }

      return _react.default.createElement(_List.NotificationItem, {
        asLink: this.asLink,
        onSelected: this.onSelected,
        item: this.item,
        overlayType: "danger",
        overlay: this.item.application.isScholarship ? 'attach_money' : 'description',
        selected: this.selected
      }, this.state.userProfile && this.state.userProfile.id == this.item.account.id ? 'Your' : _react.default.createElement(_AccountList.Account, {
        account: this.item.account,
        suffix: "'s"
      }), this.item.application.isScholarship && ' scholarship', ' application for ', _react.default.createElement("span", {
        className: "catalogItem"
      }, this.item.catalogItem.title), ' has been declined.');
    }
  }]);
  return ApplicationRejectedItem;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "item", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "onSelected", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "asLink", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "selected", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
})), _class);
exports.default = ApplicationRejectedItem;